import { reduxForm, SubmissionError } from "redux-form";
import { createFolder } from "../constants/actions";
import CreateFolderForm from "../components/forms/CreateFolderForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(createFolder({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

export default reduxForm({
  form: "createFolderForm",
  onSubmit
})(CreateFolderForm);



// WEBPACK FOOTER //
// ./src/containers/CreateFolderForm.js